export function getSubdomainFromUrl(href) {
  const url = new URL(href);

  return url.host.split('.')[1] ? url.host.split('.')[0] : null;
}

export function getSubdomain() {
  return getSubdomainFromUrl(window.location.href);
}
